import { Component, createRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, Modifier, RichUtils, getDefaultKeyBinding} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import PropTypes from 'prop-types';
import { Group, Loader, Popover, SimpleGrid, Stack, Text, Tooltip } from '@mantine/core';
import RepeatIcon from '@material-ui/icons/Repeat';
import { ColorButton, SwitchContainer } from '../../../../neoverv';
import SaveIcon from '@material-ui/icons/Save';
import BlueTick from '../../../../assets/images/module/general/BlueTick.svg'
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg'
import RedCross from '../../../../assets/images/module/general/RedCross.svg'
import GrayTick from '../../../../assets/images/module/general/GrayTick.svg'
import MessageTemplateBlue from '../../../../assets/images/module/general/MessageTemplateBlue.svg'
import AiAgentIcon from '../../../../assets/images/module/general/AiAgentIcon.svg';
import SaveAsTemplateBlue from '../../../../assets/images/module/general/SaveAsTemplateBlue.svg';
import SaveAsTemplateWhite from '../../../../assets/images/module/general/SaveAsTemplateWhite.svg';
import UpdateTemplateBlue from '../../../../assets/images/module/general/UpdateTemplateBlue.svg';
import UpdateTemplateWhite from '../../../../assets/images/module/general/UpdateTemplateWhite.svg';
import ChordComponent from './decorators/ChordComponent';
import { CompositeDecorator } from 'draft-js';
import { SelectionState } from 'draft-js';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Autoload from '../../../../neoverv/Autoload';
import TemplateServices from '../../../../neoverv/helpers/services/TemplateServices';
import { showNotification } from '@mantine/notifications';
import { IconButton } from '@material-ui/core';
import { CustomOutdentBtn } from './CustomToolBarButtons/CustomOutdentBtn';
import { CustomIndentBtn } from './CustomToolBarButtons/CustomIndentBtn';
import UpdateTemplateConfirmationModal from '../../../../neoverv/components/Module/General/CustomModal/UpdateTemplateConfirmationModal';


class CustomOption extends Component {
    static propTypes = {
      onChange: PropTypes.func,
      editorState: PropTypes.object,
    };

    state={
      scrollX: 0,
      maxScrollX: 1500,
      mouseDown: false,
      openPlaceHoldersPopover: false,
      setAsDefault: false,
      showUpdateTemplateConfirmationModal: false
    }

    constructor(props) {
      super(props);
      this.scrollRef = createRef();
      this.intervalRef = null;
    }

    componentDidMount(){
      if(this.props.isMobile === true){
        this.setState({maxScrollX: 900});
      }else{
        this.setState({maxScrollX: 1500});
      }
    }

    componentDidUpdate(prevProps){
      const {isMobile} = this.props

      if(prevProps.isMobile === false && isMobile === true){
        this.setState({maxScrollX: 900});
      }

      if(prevProps.isMobile === true && isMobile === false){
        this.setState({maxScrollX: 1500});
      }
      
    }

    startScrolling = (direction) => {
      if (this.intervalRef) return; // Prevent multiple intervals
  
      this.intervalRef = setInterval(() => {
        if (this.scrollRef.current) {
          this.scrollRef.current.scrollBy({
            top: 0,
            left: direction === "left" ? -10 : 10, // Adjust scroll speed
            behavior: "smooth",
          });
        }
      }, 50); // Adjust speed interval
    };
  
    stopScrolling = () => {
      if (this.intervalRef) {
        clearInterval(this.intervalRef);
        this.intervalRef = null;
      }
    };

    stopEvent = (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Crucial for stopping the Draft.js toolbar's native event listeners
      if (e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
    };
  
    addPlaceHolder = (placeholderName) => {
    const { editorState, onChange, subjectInFocus, addPlaceHolderToSubject } = this.props;
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();

    let placeholder = `${placeholderName}`;
    // const newContent = Modifier.replaceText(
    //   currentContent,
    //   currentSelection,
    //   placeholder
    // );
    
    //const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');

    const html = `<a href="#" class="rdw-mention-link">${placeholder}</a>`;
    if(subjectInFocus){
      addPlaceHolderToSubject(html);
    }else{
      console.log('newContent: ', html);
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
          // const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          // const editorState1 = EditorState.createWithContent(contentState);
          // const editorState2 = EditorState.moveFocusToEnd(editorState1);
  
          const newContent = Modifier.replaceWithFragment(
            currentContent,
            currentSelection,
            ContentState.createFromBlockArray(contentBlock.contentBlocks).getBlockMap()
          );
          onChange(EditorState.push(editorState, newContent, 'insert-characters'));
      }
    }
    
    
    //onChange(EditorState.push(editorState, newContent, 'insert-characters'));
    
    //return  EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());

    //console.log('addPlaceHolder: ', draftToHtml(convertToRaw(editorState.getCurrentContent())));
    
    // const html = `${draftToHtml(convertToRaw(editorState.getCurrentContent()))}<a class="rdw-mention-link"><span><span>${placeholderName}</span></span></a>&nbsp;`;
    // const contentBlock = htmlToDraft(html);
    // if (contentBlock) {
    //     const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    //     const editorState1 = EditorState.createWithContent(contentState);
    //     const editorState2 = EditorState.moveFocusToEnd(editorState1);
    //     onChange(EditorState.push(editorState2, contentState, 'insert-characters'));
    // }
    };

    renderPlaceHoldersPopover=()=>{
      const {placeholders, isMobile, allRecipients} = this.props;
      const {openPlaceHoldersPopover} = this.state;
      const externalTenantFound = allRecipients.find((recipient)=> recipient?.tenantId === null) !== undefined;
      return(
        <Popover
  opened={openPlaceHoldersPopover}
  position="top"
  withArrow
  trapFocus={false} // <-- Explicitly prevent Popover from stealing focus
  // 1. v7 uses onChange to handle clicking outside of controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ openPlaceHoldersPopover: false });
  }}
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Group 
      className="place-holder-container" 
      id="place-holder-container-id" 
      ref={this.scrollRef} // This ref is now safely attached to the target only
      style={{ marginBottom: '6px', maxWidth: isMobile ? '330px' : '550px', overflowX: 'scroll' }} 
      wrap="nowrap" 
      gap={4}
    >
      <Group 
        wrap="nowrap" 
        gap={5} 
        // Catch both MouseDown and Click to be safe
        onMouseDown={(e) => {
          this.stopEvent(e);
          this.setState({ openPlaceHoldersPopover: !openPlaceHoldersPopover });
        }} 
        onClick={this.stopEvent}
        className="editor-add-tenant-name-placeholder" 
        style={{ background: '#e6e6ff', cursor: 'pointer' }}
      >
        <span style={{ whiteSpace: 'nowrap' }}>Platzhalter</span>
      </Group>
    </Group>
  </Popover.Target>

  {/* 3. Dropdown Wrapper */}
  <Popover.Dropdown p="sm">
    <Group 
      className="place-holder-container" 
      id="place-holder-dropdown-id" // Changed ID so it doesn't conflict with target
      // ref={this.dropdownScrollRef} <-- Suggestion: Use a separate ref here if you need to track dropdown scroll
      style={{ overflowY: 'scroll', maxHeight: '200px', maxWidth: isMobile ? '250px' : '295px' }} 
      gap="sm"
      onMouseDown={this.stopEvent} // <-- Protect clicking the popover's empty background
      onClick={this.stopEvent}
    >  
      {placeholders.userName && this.renderSinglePlaceHolder('Absender')}
      {placeholders.billingPeriod && this.renderSinglePlaceHolder('Abrechnungszeitraum')}
      {placeholders.moveOutDate && this.renderSinglePlaceHolder('Auszugsdatum', externalTenantFound)}
      {placeholders.billingStatementTotalCosts && this.renderSinglePlaceHolder('Betriebskosten')}
      {placeholders.propertyOwner && this.renderSinglePlaceHolder('Eigentümer')}
      {placeholders.moveInDate && this.renderSinglePlaceHolder('Einzugsdatum', externalTenantFound)}
      {placeholders.recipient && this.renderSinglePlaceHolder('Empfänger')}
      {placeholders.recievedRent && this.renderSinglePlaceHolder('erhaltene Miete', externalTenantFound)}
      {placeholders.payableRent && this.renderSinglePlaceHolder('gesamte ausstehende Miete', externalTenantFound)}
      {placeholders.billingStatementBalance && this.renderSinglePlaceHolder('Guthaben / Nachzahlung')}
      {placeholders.netRent && this.renderSinglePlaceHolder('Kaltmiete', externalTenantFound)}
      {placeholders.tenant && this.renderSinglePlaceHolder('Mieter', externalTenantFound)}
      {placeholders.rentalUnit && this.renderSinglePlaceHolder('Mieteinheit', externalTenantFound)}
      {placeholders.rentMonth && this.renderSinglePlaceHolder('Mietmonat', externalTenantFound)}
      {placeholders.property && this.renderSinglePlaceHolder('Objektadresse')}
      {placeholders.companyName && this.renderSinglePlaceHolder('Vermieter')}
      {placeholders.billingStatementAdvancePayments && this.renderSinglePlaceHolder('Vorauszahlungen')}
      {placeholders.advancePayment && this.renderSinglePlaceHolder('Vorauszahlung', externalTenantFound)}
      {placeholders.totalRent && this.renderSinglePlaceHolder('Warmmiete', externalTenantFound)}
      {placeholders.accessLink && this.renderSinglePlaceHolder('Zugangslink')}
    </Group>
  </Popover.Dropdown>
</Popover>
      )
    }

    // Entry point for the AI message assistant. Sits next to the placeholder popover because
    // that's where the message's *content* controls live, as opposed to the formatting
    // controls the editor's own toolbar owns. The modal itself is hosted by
    // NewMessageInnerContent, which is the component that can write to both the subject and
    // the body — this only opens it.
    renderAiAssistantButton = () => {
      const {openAiAssistant} = this.props;
      if(!openAiAssistant) return null;
      return (
        <Group className="place-holder-container" style={{marginBottom: '6px'}} wrap="nowrap" gap={4}>
          <Tooltip label={'Nachricht mit KI erstellen'}>
            <Group
              wrap="nowrap"
              gap={5}
              onMouseDown={(e)=> {
                // Same aggressive stop the placeholder buttons use: without it the Draft.js
                // toolbar steals the event and the editor loses its selection.
                this.stopEvent(e);
                openAiAssistant();
              }}
              onClick={this.stopEvent}
              className="editor-add-tenant-name-placeholder"
              style={{background: '#e6e6ff', cursor: 'pointer'}}>
              <img src={AiAgentIcon} alt="ai-icon" style={{width: '13px', height: '13px', minWidth: '13px'}} />
              <span style={{whiteSpace: 'nowrap'}}>KI-Assistent</span>
            </Group>
          </Tooltip>
        </Group>
      );
    }

    renderSinglePlaceHolder = (addPlaceHolderValue, disabled=false) => {
      return (
      <Tooltip 
      label={disabled ? 'Sie haben einen externen Empfänger gewählt. Mieterbezogene Platzhalter sind in Nachrichten mit externen Empfängern nicht verfügbar.' : ''} 
      disabled={!disabled} 
      width={300}
      wrapLines={true}>
        <Group 
          wrap="nowrap" 
          gap={5} 
          onMouseDown={(e)=> {
            this.stopEvent(e); // <-- Fix: Aggressive stop
            if(!disabled) {
              this.addPlaceHolder(addPlaceHolderValue);
            }
          }} 
          onClick={this.stopEvent} // <-- Fix: Aggressive stop
          className={'editor-add-tenant-name-placeholder'} 
          style={{background: 'rgb(205, 205, 255, 0.5)', opacity: disabled ? 0.6 : 1, cursor: disabled ? 'not-allowed' : 'pointer'}}
        >
          <span style={{whiteSpace: 'nowrap'}}>{addPlaceHolderValue}</span>
        </Group>
      </Tooltip>);
    }

  compareHTML(html1, html2) {
    // 1. Quick check: if they are strictly identical (or both null), we're done.
    if (html1 === html2) return true;
    
    // 2. Safety check: if one is null/undefined and the other isn't, they don't match.
    if (!html1 || !html2) return false;

    // 3. Normalization logic
    const normalize = (str) => {
      return str
        // Remove carriage returns, newlines, and tabs
        .replace(/[\r\n\t]+/g, '')
        // Remove whitespace exactly between a closing and opening tag (> <)
        .replace(/>\s+</g, '><')
        // Collapse multiple consecutive spaces within the text into a single space
        .replace(/\s{2,}/g, ' ')
        // Remove trailing and leading spaces at the very ends of the string
        .replace(/\\/, '')
        .replace('&nbsp;', '')
        .trim();
    };

    // 4. Compare the normalized strings
    return normalize(html1) === normalize(html2);
  }
  
    render() {
      const {placeholders, savingLoader, isMobile, messageData, postTemplate, templatesButtonLoader, messageTemplates, subject, putTemplate, downloadAllAsPdf, editorState } = this.props;
      const {scrollX, maxScrollX, setAsDefault} = this.state;
      console.log('maxScrollX: ', maxScrollX, scrollX);
      let defaultTemplateFoundForUpdate = messageData?.templateId ? (messageTemplates?.length > 0 ? messageTemplates.find((template)=> template?.id == messageData?.templateId) : undefined) : undefined;
      console.log('messageTemplates: ', messageTemplates, '| subject: ', subject);
      const disableMessageTemplateSaveUpdateButton = messageData?.templateType === 'General' ? defaultTemplateFoundForUpdate ? (savingLoader || (this.compareHTML(defaultTemplateFoundForUpdate?.body, messageData?.body) && this.compareHTML(defaultTemplateFoundForUpdate?.subject, messageData?.subject))) : true : false;
      console.log('disableMessageTemplateSaveUpdateButton: ', this.compareHTML(defaultTemplateFoundForUpdate?.body, messageData?.body), this.compareHTML(defaultTemplateFoundForUpdate?.subject, messageData?.subject));
      
      console.log('defaultTemplateFoundForUpdate?.body; ', defaultTemplateFoundForUpdate?.body);
      console.log('messageData.body; ', this.compareHTML(defaultTemplateFoundForUpdate?.body, messageData?.body) );
      let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      console.log('editorState: ', body, messageData.body);
      let isBodyEqualToMessageDataBody = body ? body.replace('<p></p>\n', '') === messageData?.body?.replace('<p></p>\n', '') : false;
      let isSubjectEqualToMessageDataSubject = subject ? subject.replace('<p></p>\n', '') === messageData?.subject?.replace('<p></p>\n', '') : false;

      let isMessageCompleteEmpty = (subject === '' || subject === '<p></p>\n') && (body === '' || body === '<p></p>\n');
      
      return (
        <Group wrap="nowrap" justify="space-between" style={{flex: 1}}>
          <Group gap={4} justify="space-between" style={{width: isMobile && '100%'}} wrap={!isMobile ? "nowrap" : "wrap"}>
            {!isMobile && <Group style={{margin: '0px 5px 6px', fontWeight: '400'}}>|</Group>}
            <Group gap={10} style={{width: isMobile && '100%'}} wrap="nowrap">
              {this.renderPlaceHoldersPopover()}
              {this.renderAiAssistantButton()}
            </Group>
            {/* {!isMobile && <Group style={{margin: '0px 5px 6px', fontWeight: '400'}}>|</Group>}
            <Group gap={10} style={{width: isMobile && '100%'}} wrap="nowrap">
              <Group className='place-holder-container' id='place-holder-container-id' style={{marginBottom: '6px', maxWidth: isMobile ? '330px' : '550px', overflowX: 'scroll'}} wrap="nowrap" gap={4}>
                <Group 
                wrap="nowrap" 
                gap={5} 
                onClick={()=> 
                  postTemplate()
                } 
                className={'editor-add-tenant-name-placeholder'} 
                style={{background: '#e6e6ff'}}>
                  <span style={{whiteSpace: 'nowrap'}}>{(messageData?.templateType === 'BillingStatement' || messageData?.templateType === 'RentalPayment') ? 'Als Standard festlegen' : 'Als Vorlage speichern'}</span>
                </Group>
              </Group>
            </Group> */}
            {!isMobile && <Group style={{margin: '0px 5px 6px', fontWeight: '400'}}>|</Group>}
            {!isMobile &&
            <Group style={{marginBottom: '6px'}} wrap="nowrap">
              {savingLoader ?
              <Tooltip label={'Änderungen nicht gesichert'}>
                <Group gap={5} align={'center'} wrap="nowrap">
                  <Loader size={'xs'}/>
                  <span style={{fontSize: '14px', fontWeight: 400, fontFamily: 'Inter, sans-serif', color: '#13135C', marginTop: '-2px'}}>speichern</span>
                </Group>
              </Tooltip>
              :
              <Tooltip label={'Nachricht gesichert'}>
                <Group gap={5} align={'center'} wrap="nowrap">
                  <img src={isBodyEqualToMessageDataBody ? BlueTick : GrayTick} />
                  <span style={{fontSize: '14px', fontWeight: 400, fontFamily: 'Inter, sans-serif', color: '#13135C', marginTop: '-2px'}}>{isBodyEqualToMessageDataBody ? 'gesichert' : 'nicht gesichert'}</span>
                </Group>
              </Tooltip>
              }
            </Group>}
          </Group>
          <Group wrap="nowrap">
            {!isMessageCompleteEmpty && (messageData.templateType === 'General' || !defaultTemplateFoundForUpdate) &&
            <div style={{marginBottom: '6px'}}>
              <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>{messageData?.templateType !== 'General' ? 'Vorlage aktualisieren' : 'Als Vorlage speichern'}:</span>
              <Tooltip label={'Nachricht als neue Vorlage speichern'}>
                <IconButton 
                aria-label="filter list"
                onClick={()=> messageData?.templateType !== 'General' ? this.setState({showUpdateTemplateConfirmationModal: true}) : postTemplate()}
                style={{
                  marginLeft: '8px',
                  background: 'white',
                  border: '1px solid #DADAE5', 
                  boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                  padding: '5px',
                  cursor: 'pointer',
                  width: '28px',
                  height: '28px',
                  opacity: 1
                  }}>
                  <img src={messageData?.templateType !== 'General' ? UpdateTemplateBlue : SaveAsTemplateBlue} style={{width: '16px', height: '16px', minWidth: '16px', minHeight: '16px', marginLeft: '2px'}} />
                </IconButton>
              </Tooltip>
            </div>}
            {defaultTemplateFoundForUpdate &&
            <div style={{marginBottom: '6px'}}>
              <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>{'Vorlage aktualisieren'}:</span>
              <Tooltip label={'Aktuelle Vorlage aktualisieren'} disabled={disableMessageTemplateSaveUpdateButton}>
                <IconButton 
                aria-label="filter list"
                //disabled={savingLoader || defaultTemplateFoundForUpdate?.body === messageData.body}
                onClick={()=> !disableMessageTemplateSaveUpdateButton && putTemplate(defaultTemplateFoundForUpdate)}
                style={{
                  marginLeft: '8px',
                  background: 'white',
                  border: '1px solid #DADAE5', 
                  boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                  padding: '5px',
                  cursor: disableMessageTemplateSaveUpdateButton ? 'not-allowed' : 'pointer',
                  width: '28px',
                  height: '28px',
                  opacity: disableMessageTemplateSaveUpdateButton ? 0.8 : 1
                  }}>
                  <img src={UpdateTemplateBlue} style={{width: '16px', height: '16px', minWidth: '16px', minHeight: '16px', marginLeft: '2px'}} />
                </IconButton>
              </Tooltip>
            </div>}
            <div style={{marginBottom: '6px'}}>
              {downloadAllAsPdf}
            </div>
          </Group>
          <UpdateTemplateConfirmationModal
          open={this.state.showUpdateTemplateConfirmationModal}
          toggle={()=> this.setState({showUpdateTemplateConfirmationModal: false})}
          update={()=>{
            postTemplate();
            this.setState({showUpdateTemplateConfirmationModal: false});
          }}
          />
        </Group>
      );
    }
}

// const styleMap = {
//     'DEFAULT': {
//         color: '#000'
//     },
//     'TENANTBLOCK': {
//         color: '#4949F5'
//     },
// };

class MessagingEditor extends Component{
    decorator= new CompositeDecorator([
      {
        strategy: this.chordStrategy,
        component: ChordComponent,
        props: {
          setSelection: this.setSelection.bind(this)
        }
      }
    ])
    state={
        editorState: EditorState.createEmpty(this.decorator),
        enableTextEditor: false,
        templateName: 'Custom Template',
        templatesButtonLoader: false
    }
    constructor(props) {
        super(props);
        this.typingTimeout = null; // Timer to handle the debounce
        // const html = '<h1 style="text-align:center;"><span style="font-weight:bold;">hellohousing</span> Editor</h1>';
        // const contentBlock = htmlToDraft(html);
        // if (contentBlock) {
        //   const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        //   const editorState = EditorState.createWithContent(contentState);
        //   this.state = {
        //     editorState,
        //   };
        // }
      }

      chordStrategy(contentBlock, callback, contentState) {

        function findWithRegex(regex, contentBlock, callback) {
          const text = contentBlock.getText();
          console.log('findWithRegex: ', text);
          let matchArr, start;
          while ((matchArr = regex.exec(text)) !== null) {
            start = matchArr.index;
            callback(start, start + matchArr[0].length);
          }
        }
        findWithRegex(/<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g, contentBlock, callback);
      };

      setSelection(selectionStart, selectionEnd, blockKey) {
        const selectionState = SelectionState.createEmpty(blockKey);
        const newSelectionState = selectionState.merge({
          anchorOffset: selectionStart,
          focusOffset: selectionEnd,
        });
    
        const newEditorState = EditorState.forceSelection(this.state.editorState, newSelectionState);
        console.log('newEditorState: ', newEditorState);
        this.setState({editorState: newEditorState});
      }
      
      componentDidMount(){
        const {body} = this.props;
        if(body){
          this.htmlToDraftConversion(body);
        }
      }

      componentDidUpdate(prevProps){
        const {body} = this.props;
        if((prevProps.body === null && body !== null) || (JSON.stringify(prevProps.allRecipients) !== JSON.stringify(this.props.allRecipients))){
          if(body){
            this.htmlToDraftConversion(body);
          }
        }

      }

      htmlToDraftConversion=(data)=>{
        const {allRecipients} = this.props;
        const externalTenantFound = allRecipients.find((recipient)=> recipient?.tenantId === null) !== undefined;
        data = externalTenantFound ? this.disableAllTenantPlaceholdersInsideBody(data) : this.revertDisableAllTenantPlaceholdersInsideBody(data);
        console.log('externalTenantFound: ', externalTenantFound, allRecipients);
        
        console.log('htmlToDraftConversion: ', data);
        
        const contentBlock = htmlToDraft(data);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState1 = EditorState.createWithContent(contentState);
            const editorState2 = EditorState.moveFocusToEnd(editorState1);
            this.onEditorStateChange(editorState2);
            return 'handled';
        }
      }

      disableAllTenantPlaceholdersInsideBody = (data) => {
        // Change href="#" to href="#disabled"
        data = data.replaceAll('<a href="#" target="_self">Auszugsdatum</a>', '<a href="#disabled" target="_self">Auszugsdatum</a>');
        data = data.replaceAll('<a href="#" target="_self">Einzugsdatum</a>', '<a href="#disabled" title="Testing 1234" target="_self">Einzugsdatum</a>');
        data = data.replaceAll('<a href="#" target="_self">erhaltene Miete</a>', '<a href="#disabled" target="_self">erhaltene Miete</a>');
        data = data.replaceAll('<a href="#" target="_self">gesamte ausstehende Miete</a>', '<a href="#disabled" target="_self">gesamte ausstehende Miete</a>');
        data = data.replaceAll('<a href="#" target="_self">Kaltmiete</a>', '<a href="#disabled" target="_self">Kaltmiete</a>');
        data = data.replaceAll('<a href="#" target="_self">Mieter</a>', '<a href="#disabled" target="_self">Mieter</a>');
        data = data.replaceAll('<a href="#" target="_self">Mieteinheit</a>', '<a href="#disabled" target="_self">Mieteinheit</a>');
        data = data.replaceAll('<a href="#" target="_self">Mietmonat</a>', '<a href="#disabled" target="_self">Mietmonat</a>');
        data = data.replaceAll('<a href="#" target="_self">Vorauszahlung</a>', '<a href="#disabled" target="_self">Vorauszahlung</a>');
        data = data.replaceAll('<a href="#" target="_self">Warmmiete</a>', '<a href="#disabled" target="_self">Warmmiete</a>');

        console.log('disable-placeholder: ', data);
        
        return data;
      }

      revertDisableAllTenantPlaceholdersInsideBody = (data) => {
        // Change href="#disabled" back to href="#"
        data = data.replaceAll('<a href="#disabled" target="_self">Auszugsdatum</a>', '<a href="#" target="_self">Auszugsdatum</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Einzugsdatum</a>', '<a href="#" target="_self">Einzugsdatum</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">erhaltene Miete</a>', '<a href="#" target="_self">erhaltene Miete</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">gesamte ausstehende Miete</a>', '<a href="#" target="_self">gesamte ausstehende Miete</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Kaltmiete</a>', '<a href="#" target="_self">Kaltmiete</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Mieter</a>', '<a href="#" target="_self">Mieter</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Mieteinheit</a>', '<a href="#" target="_self">Mieteinheit</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Mietmonat</a>', '<a href="#" target="_self">Mietmonat</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Vorauszahlung</a>', '<a href="#" target="_self">Vorauszahlung</a>');
        data = data.replaceAll('<a href="#disabled" target="_self">Warmmiete</a>', '<a href="#" target="_self">Warmmiete</a>');

        console.log('revert-disable-placeholder: ', data);
        
        return data;
      }
    
      onEditorStateChange= (editorState) => {
        console.log('editorState: ', editorState);
        this.setState({
          editorState,
        }, () => {
          // Fire the auto-scroll check right after the state updates
          this.scrollToCursor();
        });

        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout);
        }

        // Set a new timeout to trigger the API call after 2 seconds of inactivity
        this.typingTimeout = setTimeout(this.handleUserStoppedTyping, 1500);
      };

      handleUserStoppedTyping = () => {
        const {editorState} = this.state;
        console.log('User stopped typing. Making API call...');
        // Replace this with your API call
        let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        this.props.updateBody(body);
        this.typingTimeout = null;
      };

      handleKeyCommand = (command, editorState) => {
        // --- 1. Custom Backspace Logic ---
        if (command === 'backspace') {
          const selection = editorState.getSelection();
          
          // Only trigger if no text is currently highlighted
          if (selection.isCollapsed()) {
            const contentState = editorState.getCurrentContent();
            const block = contentState.getBlockForKey(selection.getStartKey());
            const startOffset = selection.getStartOffset();
            
            // Ensure we aren't at the very beginning of the block
            if (startOffset > 0) {
              // Look at the character immediately to the left of the cursor
              const entityKey = block.getEntityAt(startOffset - 1);
              
              if (entityKey) {
                const entity = contentState.getEntity(entityKey);
                
                // Draft.js identifies our placeholder <a> tags as 'LINK' entities
                if (entity.getType() === 'LINK') {
                  let entityStart = startOffset - 1;
                  let entityEnd = startOffset;
                  
                  // Scan backward to find the exact start index of the placeholder
                  while (entityStart > 0 && block.getEntityAt(entityStart - 1) === entityKey) {
                    entityStart--;
                  }
                  
                  // Scan forward to find the exact end index of the placeholder
                  // (Useful in case the cursor was placed inside the placeholder instead of just after it)
                  while (entityEnd < block.getLength() && block.getEntityAt(entityEnd) === entityKey) {
                    entityEnd++;
                  }
                  
                  // Create a target range selecting the entire placeholder
                  const targetRange = selection.merge({
                    anchorOffset: entityStart,
                    focusOffset: entityEnd,
                  });
                  
                  // Delete the entire range at once
                  const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
                  const newEditorState = EditorState.push(editorState, newContent, 'remove-range');
                  this.onEditorStateChange(newEditorState);
                  return 'handled';
                }
              }
            }
          }
        }

        // --- 2. Custom Tab Logic ---
        if (command === 'handled-tab') {
          return 'handled';
        }

        if (command === 'outdent-text') {
          this.performCustomOutdent();
          return 'handled';
        }

        // --- 3. RESTORE DEFAULT DRAFT.JS SHORTCUTS (Cmd+B, Cmd+I, etc.) ---
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
          this.onEditorStateChange(newState);
          return 'handled';
        }

        return 'not-handled';
      }

      postTemplate=()=>{
        const {setAsDefault, templateName} = this.state;
        const {body, subject, messageData, profileData, accountData, propertySelected, messageTemplates} = this.props;
        console.log('postTemplate: ', body || subject);
        
        if(body || subject){
          let payload = {
            name: 'Custom Template',
            templateType: messageData?.templateType,
            subject: subject || '<p></p>',
            body: body || "<p></p>", 
            accountId: accountData?.id,
            propertyId: propertySelected?.id,
            isDefaultTemplate: messageData?.templateType !== 'General' ? true : false,
          }
          
          this.setState({templatesButtonLoader: true}, ()=> TemplateServices.postTemplates(this, 'postTemplateResponse', null, payload));
        }
      }

      postTemplateResponse(response){
        this.props.getTemplates();
        this.setState({templatesButtonLoader: false});

        if(response?.status && response?.statuscode === 200){
          showNotification({
            message: 'Ihre Vorlage wurde erfolgreich gespeichert.',
            icon: <img src={GreenTick} />,
          });

          this.props.updateTemplateId(response?.result?.id);
        }else{
          showNotification({
            message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
            icon: <img src={RedCross} />,
          });
        }
      }

      putTemplate=(templateToUpdate)=>{
        console.log('putTemplate: ', templateToUpdate);
        
        const {setAsDefault, templateName} = this.state;
        const {body, subject, messageData, profileData, accountData, propertySelected, messageTemplates} = this.props;
        console.log('putTemplate: ', body, subject);
        
        if(body || subject){
          let defaultTemplateToUpdate = templateToUpdate ? templateToUpdate : messageTemplates.find((template)=> template?.subject === subject);
          let payload = {
            ...defaultTemplateToUpdate,
            body,
            subject
          }

          this.setState({templatesButtonLoader: true}, ()=> TemplateServices.putTemplates(this, 'putTemplateResponse', null, payload));
        }
      }

      putTemplateResponse(response){
        this.props.getTemplates();
        this.setState({templatesButtonLoader: false});

        if(response?.status && response?.statuscode === 200){
          showNotification({
            message: 'Ihre Vorlage wurde erfolgreich aktualisiert.',
            icon: <img src={GreenTick} />,
          });
        }else{
          showNotification({
            message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
            icon: <img src={RedCross} />,
          });
        }
      } 

      checkDefaultMessageTemplates=(templateType)=>{
        const {messageTemplates} = this.props;
        if(templateType === 'BillingStatement' || templateType === 'RentalPayment' || templateType === 'TenantSignUp'){
          let template = messageTemplates.find((template)=>template?.templateType === templateType && template?.isDefaultTemplate);
          if(template !== undefined){
            this.setState({templatesButtonLoader: true}, ()=> TemplateServices.deleteTemplate(this, 'deleteTemplateResponse', null, template?.id));
          }else{
            this.postTemplate();
          }
        }else{
          this.postTemplate();
        }
      }

      deleteTemplateResponse(response){
        if(response?.status && response?.statuscode === 200){
          this.props.getTemplates();
          this.postTemplate();
        }
        this.setState({templatesButtonLoader: false});
      }

      scrollToCursor = () => {
        // Only perform the scroll if the editor actually has focus
        if (!this.state.editorState.getSelection().getHasFocus()) return;

        // Use a small timeout to ensure the React render cycle and DOM updates are complete
        setTimeout(() => {
          const selection = window.getSelection();
          if (selection.rangeCount > 0) {
            let node = selection.getRangeAt(0).endContainer;
            
            // If the selection is inside a text node, grab its parent element
            if (node && node.nodeType !== 1) {
              node = node.parentNode;
            }
            
            if (node) {
              // scrollIntoViewIfNeeded is highly optimized for WebKit (Chrome/Safari)
              if (node.scrollIntoViewIfNeeded) {
                node.scrollIntoViewIfNeeded(false);
              } else if (node.scrollIntoView) {
                // Standard fallback for Firefox/Edge that won't aggressively jump the page
                node.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }
          }
        }, 50);
      };

      onTab = (e) => {
        e.preventDefault(); // Prevent the browser from shifting focus out of the editor

        const { editorState } = this.state;
        const selection = editorState.getSelection();
        const contentState = editorState.getCurrentContent();
        
        // Check what kind of block the cursor is currently in
        const blockType = contentState.getBlockForKey(selection.getStartKey()).getType();
        
        // 1. If we are inside a list item, use the standard Draft.js list depth adjuster
        if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
          // CHANGE THIS NUMBER to increase max depth
          const maxDepth = 20; 
          const newState = RichUtils.onTab(e, editorState, maxDepth); 
          if (newState !== editorState) {
            this.onEditorStateChange(newState);
          }
          return true;
        }
        
        // 2. If it is simple text, insert 4 non-breaking spaces
        const newContentState = Modifier.replaceText(
          contentState,
          selection,
          '\u00a0\u00a0\u00a0\u00a0' // 4 non-breaking spaces
        );
        
        // Push the new state to the editor
        const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
        this.onEditorStateChange(newEditorState);
        return true;
      };

      customKeyBindingFn = (e) => {
        // 9 is the keycode for Tab
        if (e.keyCode === 9) {
          const { editorState } = this.state;
          const selection = editorState.getSelection();
          const contentState = editorState.getCurrentContent();
          
          // Check what kind of block the cursor is currently in
          const blockType = contentState.getBlockForKey(selection.getStartKey()).getType();
          const isList = blockType === 'unordered-list-item' || blockType === 'ordered-list-item';

          if (e.shiftKey) {
            e.preventDefault();
            
            // 1. If it's a list, route it to onTab so Draft.js can handle the bullet outdent natively
            if (isList) {
              this.onTab(e);
              return 'handled-tab';
            }
            
            // 2. If it's normal text, use our custom text outdent command
            return 'outdent-text';
          } else {
            // Manually trigger your onTab function for a normal Tab press
            this.onTab(e); 
            return 'handled-tab';
          }
        }
        return getDefaultKeyBinding(e);
      };

      // Add this method for Outdent logic
      performCustomOutdent = () => {
  const { editorState } = this.state;
  const selection = editorState.getSelection();
  const contentState = editorState.getCurrentContent();
  const block = contentState.getBlockForKey(selection.getStartKey());
  const blockType = block.getType();

  // 1. Check if we are inside a list item
  if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
    // Fake an event object with shiftKey set to true to trigger native outdent
    const fakeEvent = {
      preventDefault: () => {},
      shiftKey: true
    };
    
    const maxDepth = 20; // Keep this consistent with your maxDepth in onTab
    const newState = RichUtils.onTab(fakeEvent, editorState, maxDepth);
    
    if (newState !== editorState) {
      this.onEditorStateChange(newState);
    }
    return; // Stop execution here so we don't accidentally remove spaces
  }

  // 2. If it's normal text, proceed with your existing space-removal logic
  const text = block.getText();
  const startOffset = selection.getStartOffset();
  const textBeforeCursor = text.slice(Math.max(0, startOffset - 4), startOffset);

  let newEditorState = editorState;

  if (textBeforeCursor.match(/^[\u00a0 ]{4}$/)) {
    const targetRange = selection.merge({
      anchorOffset: startOffset - 4,
      focusOffset: startOffset,
    });
    const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
    newEditorState = EditorState.push(editorState, newContent, 'remove-range');
  } else if (text.match(/^[\u00a0 ]{4}/)) {
    const targetRange = selection.merge({
      anchorOffset: 0,
      focusOffset: 4,
    });
    const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
    newEditorState = EditorState.push(editorState, newContent, 'remove-range');
  }

  this.onEditorStateChange(newEditorState);
};

      // Add this method for Indent logic
      performCustomIndent = (e) => {
        if (e) e.preventDefault();
        // Reuse your existing onTab logic
        this.onTab(e || new Event('tab')); 
      };

      customBlockStyleFn = (contentBlock) => {
        const type = contentBlock.getType();
        const depth = contentBlock.getDepth();

        // If it's a list item and the depth is greater than 4, apply a custom class
        if ((type === 'unordered-list-item' || type === 'ordered-list-item') && depth > 4) {
          return `custom-list-depth-${depth}`;
        }
        
        return null; // Return null to let Draft.js handle standard depths (0-4) natively
      };
    
      render() {
        const { editorState, enableTextEditor, templatesButtonLoader } = this.state;
        const { placeholders, allRecipients, messageSavingLoader, subjectInFocus, addPlaceHolderToSubject, onFocus, isMobile, messageData, messageType, messageTemplates, subject, downloadAllAsPdf, openAiAssistant } = this.props;
        console.log('toolbarOnFocus: ', isMobile);
        console.log('allRecipients: ', allRecipients);
        
        return (
          <Stack>
            {isMobile &&
            <Group>
              <CustomOption editorState={editorState} isMobile={isMobile} placeholders={placeholders} savingLoader={messageSavingLoader} subjectInFocus={subjectInFocus} addPlaceHolderToSubject={addPlaceHolderToSubject} onChange={this.onEditorStateChange} messageData={messageData} postTemplate={()=> this.checkDefaultMessageTemplates(messageData?.templateType)} templatesButtonLoader={templatesButtonLoader} messageTemplates={messageTemplates} subject={subject} putTemplate={(templateToUpdate)=> this.putTemplate(templateToUpdate)} allRecipients={allRecipients} downloadAllAsPdf={downloadAllAsPdf} openAiAssistant={openAiAssistant} />
            </Group>}
            <Stack gap={0}>
              <lable>Nachricht</lable>
              <Editor
              editorState={editorState}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              toolbarClassName={isMobile && 'message-body-toolbar-mobile'}
              onEditorStateChange={this.onEditorStateChange}
              blockStyleFn={this.customBlockStyleFn}
              //toolbarOnFocus={isMobile}
              localization={{
                locale: 'de',
              }}
              //onTab={this.onTab}
              keyBindingFn={this.customKeyBindingFn}
              // onBlur={()=> {
              //   let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
              //   this.props.updateBody(body);
              // }}
              //customStyleMap={styleMap}
              customDecorators={[
                {
                  strategy: (contentBlock, callback, contentState) => {
                    contentBlock.findEntityRanges(
                      (character) => {
                        const entityKey = character.getEntity();
                        if (entityKey !== null) {
                          const entity = contentState.getEntity(entityKey);
                          // Draft.js identifies links as 'LINK'
                          if (entity.getType() === 'LINK') {
                            const data = entity.getData();
                            // Check if it has our disabled flag
                            return data.url === '#disabled' || data.href === '#disabled';
                          }
                        }
                        return false;
                      },
                      callback
                    );
                  },
                  component: ChordComponent,
                }
              ]}
              toolbar={{
                inline: {
                  strikethrough: { className: 'rdw-option-hide' },
                  monospace: { className: 'rdw-option-hide' },
                  superscript: { className: 'rdw-option-hide' },
                  subscript: { className: 'rdw-option-hide' },
                },
                list: {
                  indent: { className: 'rdw-option-hide' },
                  outdent: { className: 'rdw-option-hide' },
                },
                fontSize: {className: 'rdw-option-hide'}
            }}
            onFocus={()=> onFocus()}
            // mention={{
            //     separator: ' ',
            //     trigger: '@',
            //     suggestions: tenants.map((ten)=>{return {text: 
            //     <Group gap={5} className='message-card-ten-cards' key={ten.value} style={{height: '20.6px', maxHeight: '20.6px', background: 'transparent', width: 'auto'}}>
            //         <img src={ten.picture} style={{height: '18.6px', maxHeight: '18.6px'}}/>
            //         <span>{ten.name}</span>
            //     </Group>, 
            //     value: ten.name, url: 'apple'}}),
            // }}
            toolbarCustomButtons={isMobile ? [] : [
            <CustomIndentBtn key="indent" onCustomIndent={this.performCustomIndent} />,
            <CustomOutdentBtn key="outdent" onCustomOutdent={this.performCustomOutdent} />,
            <CustomOption  placeholders={placeholders} savingLoader={messageSavingLoader} subjectInFocus={subjectInFocus} addPlaceHolderToSubject={addPlaceHolderToSubject} messageData={messageData} postTemplate={()=> this.checkDefaultMessageTemplates(messageData?.templateType)} templatesButtonLoader={templatesButtonLoader} messageTemplates={messageTemplates} subject={subject} putTemplate={(templateToUpdate)=> this.putTemplate(templateToUpdate)} allRecipients={allRecipients} downloadAllAsPdf={downloadAllAsPdf} openAiAssistant={openAiAssistant}/>]}
              handleKeyCommand={this.handleKeyCommand}
              />
            </Stack>
            
            {/* <SwitchContainer
            checked={enableTextEditor}
            onChange={()=> this.setState({enableTextEditor: !enableTextEditor})}
            switchText={'Enable editing HTML'}
            disabled={false}
            />
            {enableTextEditor ?
            <textarea
              onBlur={(e)=> {
                this.htmlToDraftConversion(e.target.value);
              }}
              style={{ width: '100%', height: '400px'}}
              //value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
            />
            :
            <textarea
              style={{ width: '100%', height: '400px'}}
              value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
              disabled
            />} */}
            <button id="bar" type="button" style={{display: 'none'}}>Fire key event</button>
          </Stack>
        );
      }
}

export default MessagingEditor;